/**
 * TDK设置，主要用于 keywords、description
 * title 设置使用 useTitle
 */

const getMetaDomByName = (name: string) => {
  return document.querySelector(`meta[name="${name}"]`);
};

export const setKeywords = (keywords: string) => {
  const keywordsMeta = getMetaDomByName('keywords');

  keywordsMeta?.setAttribute('content', keywords);
};

export const getKeywords = () => {
  const keywordsMeta = getMetaDomByName('keywords');

  return keywordsMeta?.getAttribute('content');
};

export const addKeywords = (addWords: string) => {
  const keywords = getKeywords();

  setKeywords(`${keywords}${addWords}`);
};

export const setDescription = (description: string) => {
  const descriptionMeta = getMetaDomByName('description');

  descriptionMeta?.setAttribute('content', description);
};

export const getDescription = () => {
  const descriptionMeta = getMetaDomByName('description');

  return descriptionMeta?.getAttribute('content');
};

export const addDescription = (addDesc: string) => {
  const description = getDescription();

  setDescription(`${description}${addDesc}`);
};

const tdk = {
  setKeywords,
  getKeywords,
  setDescription,
  getDescription
};

export default tdk;
